<template lang='pug' src='./custom-office-contest.pug'></template>

<script>

export default {
  props: ['props'],
  data () {
    return {
    }
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// custom-office-contest.vue?521c4c0f